import React from 'react';
import {withStyles} from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import {BlueButton, GreenButton, GreyButton, OrangeButton} from "../common/ButtonsConstants";
import {
    AddCircleOutlineTwoTone,
    AddCircleTwoTone,
    HighlightOffTwoTone,
    SystemUpdateAltTwoTone
} from "@material-ui/icons";
import TableComponent from "../common/TableComponent";
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import TextField from "@material-ui/core/TextField";
import {NotificationContainer, NotificationManager} from "react-notifications";
import moment from "moment";
import {exportReport} from "../../util/ApiUtils";
import {Spinner} from "../common/Spinner";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Table from "@material-ui/core/Table";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import SignaturePad from "react-signature-canvas";
import {deleteReview, reviewRecords, revision, saveOrUpdateReview} from "../../util/PerformanceApiUtils";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import Modal from "@material-ui/core/Modal";
import PerformanceReviewRevisionModal from "./PerformanceReviewRevisionModal";
import * as CommonUtils from "../../util/CommonUtils";

const classes = (() => ({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
}));

const columns = [
    {
        title: 'id',
        field: 'id',
        type: "numeric",
        hidden: true,
    },
    {
        name: 'IDENTIFIER',
        id: 'displayId',
        type: "text",
        clickable: 'true'
    },
    {
        name: 'Date of the Performance Review',
        id: 'reviewDisplayDate',
        type: "text",
    },
    {
        name: 'Name of Staff Person',
        id: 'name',
        type: "text",
    },
    {
        name: 'Person conducting the assessment',
        id: 'reviewer',
        type: "text",
    },
];

const defaults = [
    { category: 'JOB KNOWLEDGE'},
    { text: 'Competent in required skills and knowledge', value: '', comments: '' },
    { text: 'Exhibits ability to learn and apply new skills', value: '', comments: '' },
    { text: 'Requires minimum supervision', value: '', comments: '' },
    { text: 'Uses resources effectively', value: '', comments: '' },
    { category: 'PLANNING AND ORGANISATION'},
    { text: 'Prioritises and plans work activities', value: '', comments: '' },
    { text: 'Integrates changes smoothly', value: '', comments: '' },
    { text: 'Sets goals and objectives', value: '', comments: '' },
    { text: 'Works in an organised manner', value: '', comments: '' },
    { category: 'INNOVATION'},
    { text: 'Develops innovative approaches and ideas', value: '', comments: '' },
    { text: 'Displays original thinking and identifies areas for improvement', value: '', comments: '' },
    { category: 'TEAM WORK'},
    { text: 'Can work as part of a team', value: '', comments: '' },
    { text: 'Identifies when the team is behind schedule and assists in developing a revised strategy', value: '', comments: '' },
    { text: 'Able to meet deadlines', value: '', comments: '' },
];

class PerformanceReviewTemplate extends React.Component {

    constructor(props) {
        super(props);
        let newPerf = [];
        defaults.map((item) => {
            if (!item.category) {
                newPerf.push({text: item.text, value: "", comments: ""})
            }
        });
        this.state = {
            title: 'ADD PERFORMANCE REVIEW',
            id: null,
            reviews: [],
            reviewDate: null,
            name: '',
            reviewer: '',
            performance: newPerf,
            improvement: '',
            staffComments: '',
            managerComments: '',
            nextReviewDate: null,
            employeeSignature: '',
            reviewerSignature: '',
            isLoading: true,
            latestRevisionDto: {},
        };
        this.loadPerf = this.loadPerf.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
        this.onNextDateChange = this.onNextDateChange.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onEdit = this.onEdit.bind(this);
        this.onClear = this.onClear.bind(this);
        this.export = this.export.bind(this);
        this.onSignature1End = this.onSignature1End.bind(this);
        this.onSignature2End = this.onSignature2End.bind(this);
        this.clear1 = this.clear1.bind(this);
        this.clear2 = this.clear2.bind(this);
        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.myRef = React.createRef();
    }

    componentDidMount() {
        this.loadPerf();
    }

    onDateChange(event, date) {
        console.log(event); //null
        console.log('date', date); //whatever the date the user picked
        this.setState({
            reviewDate: moment(date, "DD/MM/YYYY"),
        });
    }

    onNextDateChange(event, date) {
        console.log(event); //null
        console.log('date', date); //whatever the date the user picked
        this.setState({
            nextReviewDate: moment(date, "DD/MM/YYYY"),
        });
    }

    onChange({ target }) {
        this.setState({
            ...this.state, [target.name]: target.value
        });
    }

    handleChange = (event, fieldName, text) => {
        console.log('event.target.name', event.target.name);
        console.log('event.target.value', event.target.value);
        console.log('text', text);
        let newPerf = [];
        for (let index in this.state.performance) {
            console.log('index', index);
            console.log('this.state.performance[' + index + '].text', this.state.performance[index].text);
            if (this.state.performance[index].text === text) {
                if (fieldName === 'value') {
                    newPerf.push({id: this.state.performance[index].id, text: this.state.performance[index].text, value: event.target.value, comments: this.state.performance[index].comments ? this.state.performance[index].comments : ""});
                    //newPerf[index] = {"value": event.target.value, "comments": this.state.performance[index].comments};
                } else {
                    newPerf.push({id: this.state.performance[index].id, text: this.state.performance[index].text, value: this.state.performance[index].value, comments: event.target.value? event.target.value : ""});
                    //newPerf[index] = {"value": this.state.performance[index].value, "comments": event.target.value};
                }
            } else {
                newPerf.push({id: this.state.performance[index].id, text: this.state.performance[index].text, value: this.state.performance[index].value, comments: this.state.performance[index].comments ? this.state.performance[index].comments : ""});
            }
        }
        console.log('newPerf', newPerf);
        this.setState({
            ...this.state, performance: newPerf
        }, (() => { console.log('this.state.performance', this.state.performance)}) );
    };

    onSignature2End(value) {
        this.setState({
            reviewerSignature: value
        });
    }

    onSignature1End(value) {
        this.setState({
            employeeSignature: value
        });
    }

    sigPad1 = {};
    sigPad2 = {};

    clear1 = () => {
        this.sigPad1.clear()
    };

    clear2 = () => {
        this.sigPad2.clear()
    };

    loadPerf() {
        reviewRecords()
            .then(response => {
                console.log('all reviewRecords records', response);
                let newPerf = [];
                // TODO move perf to the backend and/or handle assignment of the values here
                defaults.map(item => {
                    if (!item.category) {
                        newPerf.push({text: item.text, value: "", comments: ""});
                        //newPerf[item.text]["value"] = "";
                        //newPerf[item.text]["comments"] = "";
                    }
                });
                this.setState({
                    reviews: response,
                    isLoading: false,
                    performance: newPerf
                });
                revision().then(response => {
                    this.setState({
                        latestRevisionDto: response,
                    })
                });
            });
    }

    showModal() {
        this.setState({
            show: true
        });
    }

    closeModal(updatedRevision) {
        if (updatedRevision) {
            this.setState({
                show: false,
                latestRevisionDto: updatedRevision,
            });
        } else {
            this.setState({
                show: false,
            });
        }
    }

    onClear() {
        let newPerf = [];
        // TODO move perf to the backend and/or handle assignment of the values here
        defaults.map(item => {
            if (!item.category) {
                newPerf.push({text: item.text, value: "", comments: ""});
                //newPerf[item.text]["value"] = "";
                //newPerf[item.text]["comments"] = "";
            }
        });
        this.setState({
            id: null,
            title: 'ADD PERFORMANCE REVIEW',
            reviewDate: null,
            name: '',
            reviewer: '',
            performance: newPerf,
            improvement: '',
            staffComments: '',
            managerComments: '',
            nextReviewDate: null,
            employeeSignature: '',
            reviewerSignature: '',
            reviewDisplayDate: '',
            nextReviewDisplayDate: '',
        });
        this.sigPad1.clear();
        this.sigPad2.clear();
    }

    onSave() {
        console.log("submitting...");
        console.log('this.state.performance onSave', this.state.performance);
        const record = {
            id: this.state.id,
            reviewDate: this.state.reviewDate,
            reviewer: this.state.reviewer,
            name: this.state.name,
            // FIXME reload with defaults?
            performance: this.state.performance,
            improvement: this.state.improvement,
            staffComments: this.state.staffComments,
            managerComments: this.state.managerComments,
            nextReviewDate: this.state.nextReviewDate,
            employeeSignature: this.state.employeeSignature,
            reviewerSignature: this.state.reviewerSignature,
        };
        saveOrUpdateReview(record)
            .then(() => {
                this.setState({
                    isLoading: true,
                });
                this.loadPerf();
                this.setState({
                    id: null,
                    title: 'ADD PERFORMANCE REVIEW',
                    reviewDate: null,
                    name: '',
                    reviewer: '',
                    performance: [],
                    improvement: '',
                    staffComments: '',
                    managerComments: '',
                    nextReviewDate: null,
                    employeeSignature: '',
                    reviewerSignature: '',
                    reviewDisplayDate: '',
                    nextReviewDisplayDate: '',
                }, () => NotificationManager.success('Success', 'The Performance Review has been updated.', 5000));
            })
            .catch(error => {
                console.log("error");
                console.log(error);
                NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
            });
    }

    onDelete(record) {
        console.log(record);
        deleteReview(record)
            .then(() => {
                NotificationManager.success('Success', 'The Performance Review has been removed.', 5000);
            }).catch(error => {
                NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    onEdit(review) {
        window.scrollTo(0, 0);
        let newPerf = [];
        // TODO move perf to the backend and/or handle assignment of the values here
        console.log('review.performance', review.performance);
        defaults.map(item => {
            if (!item.category) {
                let valueInDb = '';
                let commentsInDb = '';
                let id = '';
                let textDb = '';
                review.performance.map(inDb => {
                    if (inDb.text === item.text) {
                        console.log('found', inDb);
                        valueInDb = inDb.value;
                        commentsInDb = inDb.comments;
                        id = inDb.id;
                        textDb = inDb.text;
                    }
                });
                newPerf.push({id: id, text: textDb, value: valueInDb, comments: commentsInDb ? commentsInDb : ""})
                //newPerf[item.text]["value"] = valueInDb;
                //newPerf[item.text]["comments"] = commentsInDb;
            }
        });
        console.log('newPerf', newPerf);
        this.setState({
            id: review.id,
            title: 'UPDATE PERFORMANCE REVIEW',
            reviewDate: review.reviewDate,
            reviewer: review.reviewer,
            name: review.name,
            // FIXME reload with defaults?
            performance: newPerf,
            improvement: review.improvement,
            staffComments: review.staffComments,
            managerComments: review.managerComments,
            nextReviewDate: review.nextReviewDate,
            employeeSignature: review.employeeSignature,
            reviewerSignature: review.reviewerSignature,
            reviewDisplayDate: review.reviewDisplayDate,
            nextReviewDisplayDate: review.nextReviewDisplayDate,
        });
    }

    export() {
        exportReport('/performance-review/export');
    }

    onSingleEntryExport(id) {
        exportReport('/performance-review/export/single/' + id);
    }

    render() {
        let { state } = this;
        if (state.isLoading) {
            return <Spinner/>;
        }
        const { show, latestRevisionDto } = this.state;
        const isRevision = latestRevisionDto.author && latestRevisionDto.approvedBy;
        let isDemo = this.props.currentUser && this.props.currentUser.isDemo;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        return <div ref={this.myRef}>
            <Card className={classes.card}>
                <CardHeader
                    action={
                        <BlueButton
                            variant="contained"
                            color="secondary"
                            startIcon={<AddCircleOutlineTwoTone/>}
                            onClick={this.showModal}
                            size="small"
                            style={{marginRight: '10px'}}
                            disabled={isAuditor}
                        >
                            ADD
                        </BlueButton>
                    }
                    title={
                        <span style={{color: "darkblue"}}>
                            <p>{isRevision && `Revision ${latestRevisionDto.number} Author: ${latestRevisionDto.author}`}</p>
                        </span>
                    }
                    subheader={
                        isRevision &&
                        <span>
                            <p>Approved for suitability and adequacy by: {latestRevisionDto.approvedBy} on {moment(latestRevisionDto.date).format('DD/MM/YYYY')}</p>
                        </span>
                    }
                />
                <CardContent>
                    <hr/>
                    <Paper className={classes.root} style={{ width: '1000px'}}>
                        {!isAuditor && <React.Fragment>
                        <Typography variant="h6" style={{ paddingTop: '30px', paddingLeft: "30px" }}>
                            {this.state.title}
                        </Typography>
                        <div style={{ paddingLeft: "30px", paddingRight: "30px",  paddingBottom: "30px"}}>
                            <div>
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <KeyboardDatePicker
                                        disableToolbar
                                        autoOk
                                        variant="inline"
                                        format="DD/MM/YYYY"
                                        margin="normal"
                                        id="reviewDate"
                                        label="Date the Performance Review was conducted"
                                        name="reviewDate"
                                        value={state.reviewDate}
                                        onChange={ this.onDateChange }
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                        style={{ width: "600px"}}
                                    />
                                </MuiPickersUtilsProvider>
                                <div style={{ paddingTop: "20px"}}>
                                    <TextField
                                        id="name"
                                        name="name"
                                        value={state.name}
                                        label="Name of Staff person being assessed"
                                        onChange={this.onChange}
                                        style={{ width: "600px"}}
                                    />
                                </div>
                                <div style={{ paddingTop: "20px"}}>
                                    <TextField
                                        id="reviewer"
                                        name="reviewer"
                                        value={state.reviewer}
                                        label="Person conducting the assessment"
                                        onChange={this.onChange}
                                        style={{ width: "600px"}}
                                    />
                                </div>
                                <div style={{ paddingTop: "40px" }}>
                                    <Table className={classes.table} aria-label="simple table">
                                        <TableHead>
                                            <tr>
                                                <th style={{ textAlign: 'center' }}>ASSESSMENT RATINGS</th>
                                            </tr>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow key='u'>
                                                <TableCell component="td" scope="row">
                                                    U = Unsatisfactory
                                                </TableCell>
                                            </TableRow>
                                            <TableRow key='m'>
                                                <TableCell component="td" scope="row">
                                                    M = Meets job requirements
                                                </TableCell>
                                            </TableRow>
                                            <TableRow key='e'>
                                                <TableCell component="td" scope="row">
                                                    E = Exceeds job requirements
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </div>
                                <div style={{ paddingTop: "40px" }}>
                                    <Table className={classes.table} aria-label="simple table">
                                        <TableBody>
                                            {this.state.performance.map( (item, index) => {
                                                return <TableRow key='u'>
                                                    {item.category ?
                                                        <React.Fragment>
                                                            <TableCell style={{ width: '30%' }} component="td" scope="cell" colSpan={ index === 0 ? 1 : 2}>
                                                                <b>{item.category}</b>
                                                            </TableCell>
                                                            { index === 0 && <React.Fragment>
                                                            <TableCell style={{ width: '30%' }} component="td" scope="cell" colSpan="2">
                                                                <b>ASSESSMENT RATING</b>
                                                            </TableCell>
                                                            <TableCell style={{ width: '40%' }} component="td" scope="cell">
                                                                <b>COMMENTS</b>
                                                            </TableCell></React.Fragment>
                                                            }
                                                        </React.Fragment>
                                                        :
                                                        <React.Fragment>
                                                            <TableCell style={{ width: '30%' }} component="td" scope="cell">
                                                                {item.text}
                                                            </TableCell>
                                                            <TableCell style={{ width: '30%' }} component="td" scope="cell">
                                                                <FormControl className={classes.formControl} style={{ width: '200px'}}>
                                                                    <InputLabel id="demo-simple-select-label">Rating</InputLabel>
                                                                    <Select
                                                                        labelId="demo-simple-select-label"
                                                                        id="demo-simple-select"
                                                                        value={this.state.performance[index] ? this.state.performance[index].value : ''}
                                                                        name={`this.state.performance[${index}].value`}
                                                                        onChange={event => this.handleChange(event, 'value', item.text)}
                                                                    >
                                                                        <MenuItem value="Unsatisfactory">Unsatisfactory</MenuItem>
                                                                        <MenuItem value="Meets job requirements">Meets job requirements</MenuItem>
                                                                        <MenuItem value="Exceeds job requirements">Exceeds job requirements</MenuItem>
                                                                    </Select>
                                                                </FormControl>
                                                            </TableCell>
                                                            <TableCell style={{ width: '40%' }} component="td" scope="cell">
                                                                <TextField
                                                                    id="comments"
                                                                    name={`this.state.performance[${index}].comments`}
                                                                    value={this.state.performance[index] ? this.state.performance[index].comments : ''}
                                                                    label="Comments"
                                                                    onChange={event => this.handleChange(event, 'comments', item.text)}
                                                                    style={{ width: "600px"}}
                                                                    multiline
                                                                    rows="4"
                                                                />
                                                            </TableCell>
                                                        </React.Fragment>
                                                    }
                                                </TableRow>
                                            })}
                                        </TableBody>
                                    </Table>
                                </div>
                                <div style={{ paddingTop: "20px"}}>
                                    <TextField
                                        id="improvement"
                                        name="improvement"
                                        value={state.improvement}
                                        label="Improvement initiatives to be implemented"
                                        onChange={this.onChange}
                                        style={{ width: "600px"}}
                                        multiline
                                        rows="4"
                                    />
                                </div>
                                <div style={{ paddingTop: "20px"}}>
                                    <TextField
                                        id="staffComments"
                                        name="staffComments"
                                        value={state.staffComments}
                                        label="Comments from staff member"
                                        onChange={this.onChange}
                                        style={{ width: "600px"}}
                                        multiline
                                        rows="4"
                                    />
                                </div>
                                <div style={{ paddingTop: "20px"}}>
                                    <TextField
                                        id="managerComments"
                                        name="managerComments"
                                        value={state.managerComments}
                                        label="Comments from Manager (reviewer) conducting the assessment"
                                        onChange={this.onChange}
                                        style={{ width: "600px"}}
                                        multiline
                                        rows="4"
                                    />
                                </div>
                                <div style={{ width: "300px", paddingTop: "30px" }}>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <KeyboardDatePicker
                                            disableToolbar
                                            autoOk
                                            variant="inline"
                                            format="DD/MM/YYYY"
                                            margin="normal"
                                            id="nextReviewDate"
                                            label="Next scheduled performance review"
                                            name="nextReviewDate"
                                            value={state.nextReviewDate}
                                            onChange={ this.onNextDateChange }
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                            style={{ width: "300px" }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                                <div style={{ width: "400px", height: "360px", paddingTop: "30px" }}>
                                    <label>
                                        Employee Signature (Please sign below by using your mouse or touchpad):
                                    </label>
                                    <div style={{ clear: "both", borderStyle: "ridge", borderWidth: "1px", padding: "0px", display: "table-cell" }}>
                                        <SignaturePad
                                            canvasProps={{ width: "400px", height: "300px" }}
                                            onEnd={() => { console.log('onEnd called'); this.onSignature1End(this.sigPad1.toDataURL('image/png')); }}
                                            ref={(ref) => {
                                                this.sigPad1 = ref;
                                                if (state.employeeSignature && this.sigPad1) {
                                                    this.sigPad1.fromDataURL(state.employeeSignature, { width: 400, height: 300})
                                                }
                                            }}
                                        />
                                        <GreyButton onClick={this.clear1}>
                                            CLEAR
                                        </GreyButton>
                                    </div>
                                </div>
                                <div style={{ width: "400px", height: "360px", paddingTop: "60px" }}>
                                    <label>
                                        Reviewer Signature (Please sign below by using your mouse or touchpad):
                                    </label>
                                    <div style={{ clear: "both", borderStyle: "ridge", borderWidth: "1px", padding: "0px", display: "table-cell" }}>
                                        <SignaturePad
                                            canvasProps={{ width: "400px", height: "300px" }}
                                            onEnd={() => { console.log('onEnd called'); this.onSignature2End(this.sigPad2.toDataURL('image/png')); }}
                                            ref={(ref) => {
                                                this.sigPad2 = ref;
                                                if (state.reviewerSignature && this.sigPad2) {
                                                    this.sigPad2.fromDataURL(state.reviewerSignature, { width: 400, height: 300})
                                                }
                                            }}
                                        />
                                        <GreyButton onClick={this.clear2}>
                                            CLEAR
                                        </GreyButton>
                                    </div>
                                </div>
                            </div>
                            <div style={{ paddingTop: '120px', textAlign: "left" }}>
                                <OrangeButton
                                    variant="contained"
                                    color="secondary"
                                    startIcon={<HighlightOffTwoTone />}
                                    size="small"
                                    onClick={this.onClear}
                                    style={{ marginBottom: '20px', marginRight: '20px' }}
                                >
                                    CLEAR FORM
                                </OrangeButton>
                                { state.id && !isDemo &&
                                    <GreenButton
                                        variant="contained"
                                        color="secondary"
                                        startIcon={<AddCircleTwoTone/>}
                                        size="small"
                                        onClick={() => this.onSingleEntryExport(state.id)}
                                        style={{marginBottom: '20px', marginRight: '20px' }}
                                    >
                                        EXPORT
                                    </GreenButton>
                                }
                                <GreenButton
                                    variant="contained"
                                    color="secondary"
                                    startIcon={<AddCircleTwoTone />}
                                    size="small"
                                    onClick={this.onSave}
                                    style={{ marginBottom: '20px' }}
                                >
                                    SAVE
                                </GreenButton>
                            </div>
                        </div>
                        </React.Fragment>}
                        {!isDemo && <GreenButton startIcon={<SystemUpdateAltTwoTone/>} onClick={this.export} style={{ float: 'right' }}>EXPORT</GreenButton>}
                        <div style={{ paddingTop: '60px', paddingLeft: "30px", paddingRight: '30px', width: '1000px' }}>
                            <Typography component="h2" variant="h5">
                                Performance Review Template
                            </Typography>
                            <TableComponent
                                tableKey="perf_review_templ"
                                data={state.reviews}
                                columns={columns}
                                handleSubmit={this.handleSubmit}
                                handleAddRow={this.handleAddRow}
                                handleRowDel={this.onDelete}
                                handleRowEdit={this.onEdit}
                                pagination={true}
                                allowUpdateDelete={isAuditor ? 'no' : 'yes'}
                            />
                        </div>
                    </Paper>
                </CardContent>
            </Card>
            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={show}
                onClose={() => this.closeModal(null)}
            >
                <PerformanceReviewRevisionModal latestRevisionDto={state.latestRevisionDto} postSubmit={this.closeModal}/>
            </Modal>
            <NotificationContainer/>
        </div>;
    }
}

export default withStyles(classes)(PerformanceReviewTemplate);